export default {
  CUSTOMER_CELLPHONE_STATE_MANAGER: Symbol.for('CUSTOMER_CELLPHONE_STATE_MANAGER'),
  CUSTOMER_CELLPHONE_REPOSITORY:
    Symbol.for('CUSTOMER_CELLPHONE_REPOSITORY'),
  CREATE_CUSTOMER_CELLPHONE_COMMAND:
    Symbol.for('CREATE_CUSTOMER_CELLPHONE_COMMAND'),
  GET_CUSTOMER_CELLPHONE_QUERY: Symbol.for('GET_CUSTOMER_CELLPHONE_QUERY'),
};
